import { api } from "../../services/Api.js";

export function delete_teacher_talks_slot({ state }, payload ){

    // adding token
    payload.token=state.appSettings.token;
   
    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    // return chainable promise
    return api
    .post(school,"delete_teacher_talks_slot.php",payload)
    .then( result =>{ 
      return result;
    })
    .catch( error => {
      //console.log("ERROR GETTING CALENDAR",error);
      return error;
    })

}